module.exports = __webpack_public_path__ + "img/sx.1228f666.svg";